import { gql } from "@apollo/client";

export const APPLICATION_CENTER_QUERY = gql`
  query applicationCenter {
    applicationcenterdata {
      applicationcenter_id
      title
      position
      content
      status
    }
  }
`;

export const DEALER_LOCATOR_QUERY = gql`
  query getDealers($type: Int!, $regionId: Int, $cityId: Int) {
    getDealerList(
      type: $type
      countryCode: "IN"
      regionId: $regionId
      cityId: $cityId
    ) {
      id
      name
      code
      type
      address
      country
      region
      city
      pincode
      mobile
      email
      latitude
      longitude
      image
      walkthrough_url
    }
  }
`;

export const GEO_LOCATION = gql`
  query {
    getGeoLocation {
      id
      name
      regions {
        id
        regionId
        name
        cities {
          id
          name
          pincode
        }
      }
    }
  }
`;
